import React, { memo } from "react";
import { useSelector } from "react-redux";

import HeaderItem from "./subcomponents/headerItem";
import Row from "./subcomponents/rowItem";

import "./style.scss";
import { useCallback } from "react";

function Table({
  columns = [],
  rows = [],
  sort,
  sortedColumns,
  onSort,
  isLoading = false,
  pageSize = 10,
}) {
  const { mainTheme } = useSelector((state) => state.Layout);

  const raiseSort = useCallback(
    (path) => {
      if (!sort) return;
      const sortColumn = { ...sort };
      if (sortColumn.path === path)
        sortColumn.order = sortColumn.order === "asc" ? "desc" : "asc";
      else {
        sortColumn.path = path;
        sortColumn.order = "asc";
      }
      onSort?.(sortColumn);
    },
    [onSort, sort]
  );

  return (
    <div className={`table-component ${mainTheme}`}>
      <div
        className={`table-content ${isLoading ? "loading" : ""}`}
        style={{
          gridTemplateColumns: `repeat(${columns.length}, 1fr)`,
          gridTemplateRows: `repeat(${pageSize}, 1fr)`,
        }}
      >
        {columns?.map((column) => (
          <HeaderItem
            key={column.path || column.key}
            column={column}
            active={sort?.path === column.path ? sort?.order : null}
            onSort={raiseSort}
            isSorted={sortedColumns && sortedColumns.includes(column.path)}
          />
        ))}

        {rows?.map((row) => (
          <Row key={row.id} row={row} columns={columns} />
        ))}
        {!rows?.length && (
          <div className="no-data">
            <p>Nenhum dado encontrado</p>
            <span>Utilize o filtro para buscar</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(Table);
